import { i18n, type Messages } from "@lingui/core";

import { DEFAULT_LOCALE, type SupportedLocale } from "./locale";

let isInitialized = false;

/**
 * Load compiled Lingui message catalogs. Safe to call once per host bootstrap.
 */
export function loadWidgetI18nCatalogs(catalogs: Record<SupportedLocale, Messages>): void {
  if (isInitialized) {
    return;
  }

  i18n.load(catalogs);
  i18n.activate(DEFAULT_LOCALE);

  isInitialized = true;
}
